import { createSearchParams, useNavigate } from "react-router-dom";

export default function useNavigateParams() {
  const navigate = useNavigate();

  return (pathname: string, params: any) => {
    const path = {
      pathname,
      search: createSearchParams(params).toString(),
    };

    navigate(path);
  };
}
